import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { MaskedLine } from "@/components/Reveal";

export default function NotFound() {
  return (
    <section className="container-site flex min-h-[60vh] flex-col items-start justify-center py-24" data-testid="not-found-page">
      <p className="overline-label">404</p>
      <h1 className="mt-5 font-heading text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
        <MaskedLine delay={0.1}>This page took a</MaskedLine>
        <MaskedLine delay={0.25}>
          <span className="text-terracotta-500">different path.</span>
        </MaskedLine>
      </h1>
      <p className="mt-6 max-w-md text-base leading-relaxed text-muted-foreground">
        The page you're looking for doesn't exist — but the support you're looking for is right here.
      </p>
      <Link to="/" data-testid="not-found-home-button" className="btn-primary mt-8">
        <ArrowLeft className="h-4 w-4" /> Back to home
      </Link>
    </section>
  );
}
